import React from 'react';
import {Layout} from 'antd';
import "./ErrorPage.css";
import AppHeading from '../../components/AppHeading';
const {Content} = Layout;

export const ErrorPage = (props) => {
    return (
        <div className='error-page__body'>
            <AppHeading dark={true}></AppHeading>
            <Content className="error-page__content">
                <h1 className='error-page__title'>Stranica koju ste zatražili nije pronađena.</h1>
                <p className='error-page__paragraph'>Povratak na početnu stranicu dostupan je <a href="https://cikloparking.academica.hr/">ovdje</a>.</p>
            </Content>
        </div>
    );

}
